angular.module('core')
  .service('dblStudentStandardsApi', [
    'cancelableResourceManager',
    'standardsApi',
    'dblStandardsFactoryService',
    function (
        dblCancelableResourceManager,
        dblStandardsApi,
        dblStandardsFactoryService
        ) {

    this.getStudentAll = function (districtId, studentId, levelId, isAstDbl, fromDate, toDate) {
        var params = {
            districtId: districtId,
            studentId: studentId,
            fd: fromDate,
            td: toDate,
            untilNow: !(fromDate && toDate)
        };

        if (levelId) {
            params.level_id = levelId;
        }

        var studentStandardsResource = dblStandardsApi.StudentStandards.all(params);
        dblCancelableResourceManager.addAndRemoveOnFinish(studentStandardsResource);

        return studentStandardsResource.$promise.then(function(standardsData) {
            var useShortDescriptionLabel = isAstDbl;

            standardsData.levels = dblStandardsFactoryService.createStandardsLevels(standardsData.levels, useShortDescriptionLabel);

            return standardsData;
        });
    };
}]);
